import { IPreloadedState } from 'shared/types/redux';

export const selectHouseFactoids = (state: IPreloadedState) => state.houseInfo.factoids;
